package com.corbettcode.allaboutrocks.utility

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.theme.colors.ColorMode

class Extension {
}


@Composable
fun textColor(): Color.Rgb {
    val textColor = if (ColorMode.current == ColorMode.LIGHT) Colors.Black else Colors.White
    return textColor
}